import React from 'react';
import ButtonSettings from './ButtonSettings';
import { useNavigate } from 'react-router-dom';

export default function ButtonContainer() {
  const navigate = useNavigate();

  return (
    <>
      <ButtonSettings />
    </>
  );
}
